import { Grid, Heading, Text } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent } from 'react'
import { useCheckoutMode, useMerchantName } from '../../state'
import { CloseCheckout } from '../CloseCheckout'

import styles from './style.module.css'
import { TrackOnMount } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'

export const OrderComplete: FunctionComponent = () => {
  const { t } = useTranslation()
  const checkoutMode = useCheckoutMode()
  const merchantName = useMerchantName()

  return (
    <>
      <div className={styles.headingWrapper}>
        <Heading size='XXL'>{t('common:closed.heading')}</Heading>
      </div>
      <div className={styles.contentWrapper}>
        <Grid>
          <Text size='M'>{t('common:closed.description', { context: checkoutMode.toLowerCase(), merchantName })}</Text>
        </Grid>
        <Grid>
          <Grid.Item>
            <CloseCheckout type='button' padding='Fluid'>
              {t('common:closed.cta')}
            </CloseCheckout>
          </Grid.Item>
        </Grid>
      </div>
      <TrackOnMount eventName={TrackingEvent.VIEWED_ORDER_COMPLETE} />
    </>
  )
}
